import { Menu } from "antd";
import React, { useEffect, useState } from "react";
import { getPrecursorCategories } from '../api/chemicalRegistry';
import { useParams } from 'react-router-dom';

interface SubmenuGroupsProps {
  onGroupSelect?: (group: string) => void;
  selectedGroup?: string;
}

const SubmenuGroups: React.FC<SubmenuGroupsProps> = ({ onGroupSelect, selectedGroup }) => {
  const { laboratoryId } = useParams<{ laboratoryId: string }>();
  const [categories, setCategories] = useState<string[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchCategories = async () => {
      console.log('🔍 SubmenuGroups: fetchCategories called, laboratoryId:', laboratoryId);
      if (!laboratoryId) {
        console.log('❌ SubmenuGroups: laboratoryId is undefined, skipping fetch');
        setLoading(false);
        return;
      }
      
      try {
        setLoading(true);
        console.log('📡 SubmenuGroups: calling getPrecursorCategories with laboratoryId:', laboratoryId);
        const fetchedCategories = await getPrecursorCategories(laboratoryId);
        console.log('✅ SubmenuGroups: received categories:', fetchedCategories);
        setCategories(fetchedCategories);
      } catch (error) {
        console.error('❌ SubmenuGroups: Error fetching precursor categories:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchCategories();
  }, [laboratoryId]);

  const handleMenuClick = ({ key }: { key: string }) => {
    const categoryName = categories[parseInt(key)];
    console.log('🏷️ SubmenuGroups: menu click, selecting category:', categoryName, 'key:', key, 'all categories:', categories);
    if (categoryName && onGroupSelect) {
      console.log('✅ SubmenuGroups: calling onGroupSelect with category:', categoryName);
      onGroupSelect(categoryName);
    } else {
      console.log('❌ SubmenuGroups: categoryName is empty or onGroupSelect is undefined');
    }
  };

  if (loading) {
    return (
      <div style={{ 
        width: 200,
        padding: 16,
        textAlign: 'center'
      }}>
        Загрузка...
      </div>
    );
  }

  if (categories.length === 0) {
    return (
      <div style={{ 
        width: 200,
        padding: 16,
        textAlign: 'center',
        color: '#999'
      }}>
        Нет доступных категорий
      </div>
    );
  }

  return (
    <Menu 
      mode="inline" 
      style={{ 
        width: 200,
        borderInlineEnd: 'none',
        padding: 0,
        margin: 0,
        maxHeight: 300,
        overflowY: 'auto'
      }}
      onClick={handleMenuClick}
      selectedKeys={selectedGroup && categories.includes(selectedGroup) ? [categories.indexOf(selectedGroup).toString()] : []}
    >
      {categories.map((category, index) => (
        <Menu.Item key={index.toString()}>{category}</Menu.Item>
      ))}
    </Menu>
  );
};

export default SubmenuGroups;
